import { EPromoType } from '../../repositories/newbuilding-promos/entities/promo/PromoDesktopSchema';
import { ISearchPromosV2ResponseSchema } from '../../repositories/newbuilding-promos/entities/search_promos_v2/SearchPromosV2ResponseSchema';
import { TProductsById } from '../../types/analytics';
import { EProductType, TProduct } from '../../types/product';

const PRODUCT_TYPE_MAP = new Map<EPromoType, EProductType>([
  [EPromoType.Bonus, EProductType.Bonus],
  [EPromoType.CianMortgage, EProductType.CianMortgage],
  [EPromoType.Discount, EProductType.Discount],
  [EPromoType.MaternalCapital, EProductType.MaternalCapital],
  [EPromoType.Military, EProductType.MilitaryMortgage],
  [EPromoType.Mortgage, EProductType.Mortgage],
]);

export const mapProducts = (promosResponse: ISearchPromosV2ResponseSchema) => {
  const productsById: TProductsById = {};
  const products: TProduct[] = [];

  promosResponse.promoSearchResult.promos.forEach(promo => {
    const product: TProduct = {
      id: promo.providerPromoId,
      offerType: 'promo',
      extra: {
        type: PRODUCT_TYPE_MAP.get(promo.promoType) as EProductType,
        name: promo.promoName,
        uniquePromoId: promo.uniquePromoId,
      },
    };

    productsById[promo.uniquePromoId] = product;
    products.push(product);
  });

  return { products, productsById };
};
